import { createRoot } from 'react-dom/client';
import { getIdAttribute, getYesAttribute } from '@repo/widget-utils/attributes/attribute-helper';
import BilberryCustomElement from 'src/widgets/BilberryCustomElement';
import { WidgetWrapper } from 'src/widgets/WidgetWrapper';
import { BookingContextProvider } from 'src/widgets/BookingContext';
import PackageBookingInline from './PackageBookingInline';

class PackageBookingInlineWidget extends BilberryCustomElement {
    protected renderWidget(): void {
        const packageId = getIdAttribute(this, false, 'package-id');
        const dateSelectionFirst = getYesAttribute(this, 'date-selection-first');

        createRoot(this._mountPoint).render(
            <WidgetWrapper
                mountPoint={this._mountPoint}
                popoverMountPoint={this._popoverMountPoint}
                shadowRoot={this._shadowRoot}
            >
                <BookingContextProvider>
                    <PackageBookingInline
                        packageId={packageId}
                        dateSelectionFirst={dateSelectionFirst}
                    />
                </BookingContextProvider>
            </WidgetWrapper>,
        );
    }
}

export default function defineCustomElement() {
    customElements.define('bilberry-package-booking-inline', PackageBookingInlineWidget);
}
